<template>
    <div>
        <van-list
           v-if="mainList.length"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
            <van-cell v-for="(item,index) in mainList" :key="index" :title="item.name" is-link @click="goPage(item)">
                <template slot="default">
                    <span class="">更新日期</span>
                    {{item.time}}
                </template>
            </van-cell>
       </van-list>
       <empty v-if="nodata"></empty>
    </div>
</template>
<style lang='scss' scoped>
.van-cell{
    .van-cell__title{
        font-size:16px;
    }
    .van-cell__value{
        font-size:13px;
    }
}
</style>
<script>
    import empty from '@/components/empty'
    export default {
        components:{
            empty
        },
        data(){
           return {
                loading: false,
                finished: false,
                mainList:[],
                pageNum:1,
                pageSize:20,
                nodata:null
           }
        },
        mounted(){
             this.getPrivacyAgreementByappid(true)
        },
        methods:{
            goPage(item){
                this.$router.push({path:'/policyDetail',query:{appid:this.$route.query.appid,id:item.id}})
            },
            getPrivacyAgreementByappid(refresh){
                if(refresh){
                    this.pageNum=1
                    this.mainList=[]
                }else{
                    this.pageNum++
                }
                this.$get({
                    url:this.$apis.getPrivacyAgreementByappid,
                    query:{
                        appid:this.$route.query.appid,
                        type:1,
                        pageNum:this.pageNum,
                        pageSize:this.pageSize
                    }
                }).then(res =>{
                    this.loading = false;
                    this.mainList = [...this.mainList,...res.data.list]
                    this.hasNextPage=res.data.hasNextPage
                    if(!this.hasNextPage){
                         this.finished = true;
                    }
                    this.nodata = this.$util.switchNodata(this.mainList)
                })  
            },
            onLoad(){
                if(this.hasNextPage){
                    this.getPrivacyAgreementByappid()
                }
            }
        }
    }
</script>